import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=236454a3&scoped=true"
import script from "./operation.vue?vue&type=script&lang=ts"
export * from "./operation.vue?vue&type=script&lang=ts"
import style0 from "./operation.vue?vue&type=style&index=0&id=236454a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236454a3",
  null
  
)

export default component.exports